import React from 'react';
import { EMAIL_SLIDE, PAUSE_SLIDE, PLAN_GRAPH_SLIDE, PLAN_LOADER_SLIDE, PRODUCT_SLIDE, PROFILE_SLIDE, QUESTION_ANSWER_SLIDE_COMPONENT, QUESTION_MULTI_ANSWER_SLIDE_COMPONENT, REVIEW_SLIDE, START_SLIDE } from '../quiz-component-types';
import pauseArmchairTabletSrc from '../../assets/images/slide/pause-armchair-tablet.png';
import pausePhoneRecordingSrc from '../../assets/images/slide/pause-phone-recording.png';
import pausePhoneRecordingAgeBranchSrc from '../../assets/images/slide/pause-phone-recording-2.png';

const PLAN_TOPIC_ANSWERS = [
    {
        text: 'The home I grew up in',
        icon: 'house',
        id: 1
    },
    {
        text: 'My first job',
        icon: 'briefcase',
        id: 2
    },
    {
        text: 'A hard year I got through',
        icon: 'flexed-biceps',
        id: 3
    },
    {
        text: 'The people who raised me',
        icon: 'family-man-woman-girl',
        id: 4
    }
];

const PLAN_LOADER_REVIEWS = [
    {
        id: 1,
        title: 'As easy as talking to an old friend',
        quote: 'I’m not big on technology, but Boundly made it feel like chatting with an old friend.',
        name: 'Paul',
        date: 'September',
        initial: 'P',
        avatarColor: '#944343'
    },
    {
        id: 2,
        title: 'Mom’s stories we never knew',
        quote: 'My mom remembered stories from her whole life — the best gift we’ve ever given her.',
        name: 'Natalie',
        date: 'September',
        initial: 'N',
        avatarColor: '#5C8C5E'
    },
    {
        id: 3,
        title: 'A bridge to my kids, one story at a time',
        quote: 'My kids live abroad, and through my stories, I hope we’ll feel more connected.',
        name: 'Ruby',
        date: 'September',
        initial: 'R',
        avatarColor: '#3A6194'
    }
];

const QUIZ_SLIDES_V34 = [
    {
        id: 900,
        component: START_SLIDE,
        isNotIndexing: true
    },
    {
        id: 9001,
        component: PAUSE_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            variant: 'v13',
            imageSrc: `${pauseArmchairTabletSrc}?v=2`,
            title: 'Let’s preserve what only you can tell',
            description: <p>No writing skills needed. A few gentle questions, <b>a few minutes at a time</b> — in your own words, for yourself and for anyone you choose to share them with.</p>
        }
    },
    {
        id: 9010,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'What you remember',
            question: 'How old are you?',
            answers: [
                {
                    text: '29 or less',
                    id: 1
                },
                {
                    text: '30–39',
                    id: 2
                },
                {
                    text: '40–49',
                    id: 3
                },
                {
                    text: '50–59',
                    id: 4
                },
                {
                    text: '60–69',
                    id: 5
                },
                {
                    text: '70+',
                    id: 6
                }
            ]
        }
    },
    {
        id: 9012,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'What you remember',
            question: 'Is there a song that takes you straight back to another time?',
            answers: [
                {
                    text: 'Yes, instantly',
                    icon: 'music-note',
                    id: 1
                },
                {
                    text: 'Maybe one or two',
                    icon: 'thinking-face',
                    id: 2
                },
                {
                    text: 'Not really',
                    icon: 'blank-face',
                    id: 3
                }
            ]
        }
    },
    {
        id: 9013,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'What you remember',
            question: 'Can you remember a meal from years ago just by its smell or taste?',
            answers: [
                {
                    text: 'Yes, clearly',
                    icon: 'smile',
                    id: 1
                },
                {
                    text: 'A little',
                    icon: 'pinching-hand',
                    id: 2
                },
                {
                    text: 'Not really',
                    icon: 'shrug',
                    id: 3
                }
            ]
        }
    },
    {
        id: 9014,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'What you remember',
            question: 'Can you picture the place where you spent most of your childhood?',
            answers: [
                {
                    text: 'Yes, clearly',
                    icon: 'house',
                    id: 1
                },
                {
                    text: 'Some parts of it',
                    icon: 'puzzle',
                    id: 2
                },
                {
                    text: 'Not really',
                    icon: 'shrug',
                    id: 3
                }
            ]
        }
    },
    {
        id: 9015,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'What you remember',
            question: '“I remember what happened, but the details are getting harder to find.”',
            description: 'Does this feel familiar?',
            answers: [
                {
                    text: 'Yes, that’s me',
                    icon: 'person-raising-hand',
                    id: 1
                },
                {
                    text: 'Sometimes',
                    icon: 'refresh',
                    id: 2
                },
                {
                    text: 'No, not really',
                    icon: 'shrug',
                    id: 3
                }
            ]
        }
    },
    {
        id: 9016,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'What you remember',
            question: 'How often do names or dates slip away while you’re telling a story?',
            answers: [
                {
                    text: 'Almost never',
                    icon: 'brain',
                    id: 1
                },
                {
                    text: 'Now and then',
                    icon: 'refresh',
                    id: 2
                },
                {
                    text: 'Often',
                    icon: 'laughing',
                    id: 3
                },
                {
                    text: 'Almost every time',
                    icon: 'peeking-face',
                    id: 4
                }
            ]
        }
    },
    {
        id: 9002,
        component: PAUSE_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            variant: 'v14'
        }
    },
    {
        id: 9017,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'What remains',
            question: 'Have you ever wished you’d asked someone in your family more about their life?',
            answers: [
                {
                    text: 'Yes, very much',
                    icon: 'heart-red',
                    id: 1
                },
                {
                    text: 'Sometimes',
                    icon: 'thinking-face',
                    id: 2
                },
                {
                    text: 'Not really',
                    icon: 'relieved-face',
                    id: 3
                }
            ]
        }
    },
    {
        id: 9018,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'What remains',
            question: 'Is there a story that would disappear if you didn’t tell it?',
            answers: [
                {
                    text: 'More than one',
                    icon: 'books',
                    id: 1
                },
                {
                    text: 'Probably one',
                    icon: 'book',
                    id: 2
                },
                {
                    text: 'I haven’t thought about it',
                    icon: 'thought-ballon',
                    id: 3
                }
            ]
        }
    },
    {
        id: 9019,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'What remains',
            question: 'How much of your life story does your family actually know?',
            answers: [
                {
                    text: 'Most of it',
                    icon: 'glowing-star',
                    id: 1
                },
                {
                    text: 'Some of it',
                    icon: 'sun-behind-small-cloud',
                    id: 2
                },
                {
                    text: 'Very little',
                    icon: 'crescent-moon',
                    id: 3
                }
            ]
        }
    },
    {
        id: 9020,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'What remains',
            question: 'If someone in your family wanted to know who you were, what would they find today?',
            answers: [
                {
                    text: 'A few photos',
                    icon: 'camera-with-flash',
                    id: 1
                },
                {
                    text: 'Some papers and letters',
                    icon: 'love-letter',
                    id: 2
                },
                {
                    text: 'Something I’ve written',
                    icon: 'writing',
                    id: 3
                },
                {
                    text: 'Almost nothing',
                    icon: 'blank-face',
                    id: 4
                }
            ]
        }
    },
    {
        id: 9021,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'What remains',
            question: '“If I never record them, some of my stories may disappear with me.”',
            description: 'Does this thought feel true?',
            answers: [
                {
                    text: 'Yes, it does',
                    icon: 'face-holding-back-tears',
                    id: 1
                },
                {
                    text: 'Not really',
                    icon: 'relieved-face',
                    id: 2
                }
            ]
        }
    },
    {
        id: 9022,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'What remains',
            question: '“I’d like to leave behind something more than money or things.”',
            description: 'Does this sound like you?',
            answers: [
                {
                    text: 'Yes, very much',
                    icon: 'sparkles',
                    id: 1
                },
                {
                    text: 'Somewhat',
                    icon: 'thought-ballon',
                    id: 2
                },
                {
                    text: 'Not really',
                    icon: 'shrug',
                    id: 3
                }
            ]
        }
    },
    {
        id: 9023,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'What remains',
            question: 'Who would be the first to read it?',
            answers: [
                {
                    text: 'My children',
                    icon: 'girl',
                    id: 1
                },
                {
                    text: 'My grandchildren',
                    icon: 'baby',
                    id: 2
                },
                {
                    text: 'My nieces and nephews',
                    icon: 'family-woman-girl-boy',
                    id: 3
                },
                {
                    text: 'My husband or wife',
                    icon: 'couple-with-heart',
                    id: 4
                },
                {
                    text: 'Someone who hasn’t been born yet',
                    icon: 'seedling',
                    id: 5
                },
                {
                    text: 'Nobody in particular — just me',
                    icon: 'mirror',
                    id: 6
                }
            ]
        }
    },
    {
        id: 9003,
        component: PAUSE_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            variant: 'v13',
            imageSrc: pausePhoneRecordingSrc,
            title: 'Nobody means for it to disappear',
            description: (
                <>
                    <p>You think you’ll remember it all. <strong>But nobody writes down every story</strong>, every person, every little detail — there’s never the right evening, and then time moves on.</p>
                    <p>It doesn’t take an evening. <strong>One question</strong> at a time.</p>
                </>
            )
        }
    },
    {
        id: 9024,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'Why it never started',
            question: 'Have you ever started something like this and stopped?',
            answers: [
                {
                    text: 'Yes, more than once',
                    icon: 'refresh',
                    id: 1
                },
                {
                    text: 'Once',
                    icon: 'index-pointing-up',
                    id: 2
                },
                {
                    text: 'Never tried',
                    icon: 'new-button',
                    id: 3
                }
            ]
        }
    },
    {
        id: 9025,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'Why it never started',
            question: '“I’m not a writer. Typing out long stories isn’t for me.”',
            description: 'Does this sound like you?',
            answers: [
                {
                    text: 'That’s me',
                    icon: 'person-raising-hand',
                    id: 1
                },
                {
                    text: 'A little',
                    icon: 'pinching-hand',
                    id: 2
                },
                {
                    text: 'Not really',
                    icon: 'shrug',
                    id: 3
                }
            ]
        }
    },
    {
        id: 9026,
        component: QUESTION_MULTI_ANSWER_SLIDE_COMPONENT,
        continueButton: {
            isVisible: true
        },
        props: {
            category: 'Why it never started',
            question: 'What makes recording your story feel difficult?',
            description: 'Choose all that apply',
            answers: [
                {
                    text: 'I would not know where to begin',
                    icon: 'thinking-face',
                    id: 1
                },
                {
                    text: 'It sounds like too much writing',
                    icon: 'writing',
                    id: 2
                },
                {
                    text: 'I do not have enough time',
                    icon: 'alarm-clock',
                    id: 3
                },
                {
                    text: 'Technology can feel complicated',
                    icon: 'mobile-phone',
                    id: 4
                },
                {
                    text: 'Some memories are difficult to revisit',
                    icon: 'thought-ballon',
                    id: 5
                }
            ]
        }
    },
    {
        id: 9027,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'Why it never started',
            question: 'If it only took ten minutes at a time, would you do it?',
            answers: [
                {
                    text: 'Yes, I would',
                    icon: 'check-mark-button',
                    id: 1
                },
                {
                    text: 'I’d like to think so',
                    icon: 'crossed-fingers',
                    id: 2
                }
            ]
        }
    },
    {
        id: 9028,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'Your plan',
            question: 'Would you rather tell your stories out loud or write them?',
            answers: [
                {
                    text: 'Out loud',
                    icon: 'speaking-head',
                    id: 1
                },
                {
                    text: 'In writing',
                    icon: 'writing',
                    id: 2
                },
                {
                    text: 'A bit of both',
                    icon: 'shuffle-tracks-button',
                    id: 3
                }
            ]
        }
    },
    {
        id: 9004,
        component: PRODUCT_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            variant: 'v8'
        }
    },
    {
        id: 908,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'Why it never started',
            question: 'Which story should we begin with?',
            description: 'You can change this any time',
            answers: PLAN_TOPIC_ANSWERS
        }
    },
    {
        id: 9005,
        component: REVIEW_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        }
    },
    {
        id: 945,
        component: EMAIL_SLIDE,
        isNotIndexing: true,
        props: {
            title: 'Your Life Story Plan is ready',
            description: 'We will use your email to save your answers and show your personalized starting point.',
            placeholder: 'Your email address',
            agreementText: 'We’ll use your email to save your plan and send you updates about Boundly. You can unsubscribe at any time. See our '
        }
    },
    {
        id: 944,
        component: PLAN_LOADER_SLIDE,
        isNotBackButton: true,
        isNotIndexing: true,
        props: {
            heading: 'Building your Life Story Plan',
            steps: ['Reading your answers', 'Choosing where to start', 'Putting your plan together'],
            reviews: PLAN_LOADER_REVIEWS
        }
    },
    {
        id: 9006,
        component: PROFILE_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        }
    },
    {
        id: 946,
        component: PLAN_GRAPH_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        }
    },
    {
        id: 9007,
        component: PRODUCT_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            variant: 'v9'
        }
    }
];

const AGE_BRANCH_SLIDES_V34 = {
    questionId: 9010,
    branchAnswerIds: [1, 2, 3],
    slides: {
        9002: {
            id: 9002,
            component: PAUSE_SLIDE,
            isNotIndexing: true,
            continueButton: {
                isVisible: true
            },
            props: {
                variant: 'v14',
                heading: 'Stories don’t fade from memory. They fade from the family.',
                description: 'You remember the song, the taste, the house you grew up in. But no one else can see inside your head — and within two generations, even names get lost.',
                emphasis: 'The stories that last are the ones someone took the time to keep.',
                statValue: '53%',
                statText: 'of adults can’t name all four of their grandparents',
                statTextUs: 'of Americans can’t name all four of their grandparents',
                statSource: '*Ancestry / OnePoll survey of 2,113 U.S. adults, 2022',
                withSeparateEmphasis: true
            }
        },
        9020: {
            id: 9020,
            component: QUESTION_ANSWER_SLIDE_COMPONENT,
            props: {
                category: 'What remains',
                question: 'If someone in your family wanted to know who you were, what would they find today?',
                answers: [
                    {
                        text: 'Thousands of photos on my phone',
                        icon: 'mobile-phone',
                        id: 1
                    },
                    {
                        text: 'Old posts and messages',
                        icon: 'thought-ballon',
                        id: 2
                    },
                    {
                        text: 'Something I’ve written',
                        icon: 'writing',
                        id: 3
                    },
                    {
                        text: 'Almost nothing',
                        icon: 'smile',
                        id: 4
                    }
                ]
            }
        },
        9021: {
            id: 9021,
            component: QUESTION_ANSWER_SLIDE_COMPONENT,
            props: {
                category: 'What remains',
                question: '“There are parts of my story no one will ever hear unless I write them down.”',
                description: 'Does this thought feel true?',
                answers: [
                    {
                        text: 'Yes, it does',
                        icon: 'face-holding-back-tears',
                        id: 1
                    },
                    {
                        text: 'Not really',
                        icon: 'relieved-face',
                        id: 2
                    }
                ]
            }
        },
        9022: {
            id: 9022,
            component: QUESTION_ANSWER_SLIDE_COMPONENT,
            props: {
                category: 'What remains',
                question: '“I want to understand my own story — not just live it.”',
                description: 'Does this sound like you?',
                answers: [
                    {
                        text: 'Yes, very much',
                        icon: 'sparkles',
                        id: 1
                    },
                    {
                        text: 'Somewhat',
                        icon: 'thought-ballon',
                        id: 2
                    },
                    {
                        text: 'Not really',
                        icon: 'shrug',
                        id: 3
                    }
                ]
            }
        },
        9023: {
            id: 9023,
            component: QUESTION_ANSWER_SLIDE_COMPONENT,
            props: {
                category: 'What remains',
                question: 'Who would be the first to read it?',
                answers: [
                    {
                        text: 'My children — now or someday',
                        icon: 'girl',
                        id: 1
                    },
                    {
                        text: 'My partner',
                        icon: 'couple-with-heart',
                        id: 2
                    },
                    {
                        text: 'My parents or siblings',
                        icon: 'family-man-woman-girl',
                        id: 3
                    },
                    {
                        text: 'My closest friends',
                        icon: 'handshake',
                        id: 4
                    },
                    {
                        text: 'Nobody in particular — just me',
                        icon: 'mirror',
                        id: 5
                    }
                ]
            }
        },
        9003: {
            id: 9003,
            component: PAUSE_SLIDE,
            isNotIndexing: true,
            continueButton: {
                isVisible: true
            },
            props: {
                variant: 'v13',
                imageSrc: pausePhoneRecordingAgeBranchSrc,
                title: 'The photo survives. The story behind it doesn’t.',
                description: (
                    <>
                        <p>Your phone keeps thousands of moments, <b>but not why they mattered</b> — who you were then, what was said, what it changed. And life keeps moving faster than you can write it down.</p>
                        <p>It doesn’t take an evening. <strong>One question</strong> at a time.</p>
                    </>
                )
            }
        },
        9026: {
            id: 9026,
            component: QUESTION_MULTI_ANSWER_SLIDE_COMPONENT,
            continueButton: {
                isVisible: true
            },
            props: {
                category: 'Why it never started',
                question: 'What makes recording your story feel difficult?',
                description: 'Choose all that apply',
                answers: [
                    {
                        text: 'I would not know where to begin',
                        icon: 'thinking-face',
                        id: 1
                    },
                    {
                        text: 'It sounds like too much writing',
                        icon: 'writing',
                        id: 2
                    },
                    {
                        text: 'I do not have enough time',
                        icon: 'alarm-clock',
                        id: 3
                    },
                    {
                        text: 'I’m not sure my story is interesting enough',
                        icon: 'shrug-hands',
                        id: 4
                    },
                    {
                        text: 'Some memories are difficult to revisit',
                        icon: 'thought-ballon',
                        id: 5
                    }
                ]
            }
        },
        9004: {
            id: 9004,
            component: PRODUCT_SLIDE,
            isNotIndexing: true,
            continueButton: {
                isVisible: true
            },
            props: {
                variant: 'v8',
                description: 'Some are recording for their kids. Some to finally make sense of their own story. Talk or type. We do the rest.'
            }
        }
    }
};

export {
    QUIZ_SLIDES_V34,
    AGE_BRANCH_SLIDES_V34
};
